export const UPGRADES = {
  extraTime: {
    id: 'extraTime',
    name: 'Extra Time',
    description: '+2 seconds per word',
    baseCost: 200,
    costMultiplier: 1.5,
    getCurrentValue: (state) => {
      if (!state || typeof state.timePerWord !== 'number') return 4;
      return Math.floor(state.timePerWord / 1000);
    },
    formatCurrentValue: (value) => `Current: ${value || 4}s per word`,
    effect: (state) => { state.timePerWord += 2000; }
  },
  extraLife: {
    id: 'extraLife',
    name: 'Extra Life', 
    description: '+1 life',
    baseCost: 300,
    costMultiplier: 1.8,
    getCurrentValue: (player) => {
      if (!player || typeof player.lives !== 'number') return 3;
      return player.lives;
    },
    formatCurrentValue: (value) => `Current: ${value || 3} lives`,
    effect: (player) => { player.lives += 1; }
  },
  mistakeForgiveness: {
    id: 'mistakeForgiveness',
    name: 'Mistake Shield',
    description: 'One free mistake per round',
    baseCost: 400,
    costMultiplier: 2.0,
    getCurrentValue: (player) => {
      if (!player) return 0;
      return player.mistakeShield ? 1 : 0;
    },
    formatCurrentValue: (value) => `Current: ${value ? 'Active' : 'Inactive'}`,
    effect: (player) => { player.mistakeShield = true; }
  },
  pointMultiplier: {
    id: 'pointMultiplier',
    name: 'Point Boost',
    description: '1.5x points',
    baseCost: 500,
    costMultiplier: 2.5,
    getCurrentValue: (player) => {
      if (!player || typeof player.pointMultiplier !== 'number') return 1.0;
      return player.pointMultiplier;
    },
    formatCurrentValue: (value) => `Current: ${value || 1.0}x points`,
    effect: (player) => { player.pointMultiplier = 1.5; }
  }
};
